import React, { useMemo } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdOutlineAppRegistration,
	MdOutlineBusiness,
	MdOutlineChecklist,
	MdOutlineMessage,
	MdOutlinePlace,
	MdSettingsSuggest,
	MdTune,
} from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { BiBox, BiCoinStack, BiImport, BiPlusMedical } from "react-icons/bi";
import {
	AlertOutlined,
	CalendarOutlined,
	LoginOutlined,
	SettingOutlined,
	StockOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { FaHeadset } from "react-icons/fa";
import { TbDeviceMobile } from "react-icons/tb";
import { useFilter } from "../../../../../../contexts/filterContext";
import {
	GiArtificialIntelligence,
	GiFiles,
	GiPoolTriangle,
	GiToken,
} from "react-icons/gi";
import { useAuth } from "../../../../../../contexts/authContext";
import { CONSTANTS } from "../../../../../../utils/constants";
import { MdTrackChanges } from "react-icons/md";
import { Badge } from "antd";
import { COLORS } from "../../../../../layout/theme";
import DefaultButton from "../../../../../common/antd-buttons/DefaultButton";
import SecondaryButton from "../../../../../common/antd-buttons/SecondaryButton";
import PrimaryButton from "../../../../../common/antd-buttons/PrimaryButton";

export default function ModuleErp({
	clientContract,
	userdata,
	activeSection,
	clientId,
}) {
	const { agentOrdersQty } = useAuth();
	const { setAdminUsersType } = useFilter();
	const navigate = useNavigate();

	const generalItems = useMemo(() => {
		const items = [];

		if (
			clientContract &&
			!userdata.isAgency &&
			clientContract.activeMobileApp &&
			clientContract.mobileUsersZoneType === CONSTANTS.USER_ZONE_TYPE_ROUTE
		) {
			items.push({
				to: "/admin/laboratoryRoutes?uri=generalConfig",
				title: "Puntos de venta",
				desc: "Administración de puntos de venta asignados",
				icon: <BiPlusMedical size={16} />,
			});
		}

		if (
			clientContract &&
			!userdata.isAgency &&
			clientContract.activeMobileApp &&
			clientContract.mobileUsersZoneType === CONSTANTS.USER_ZONE_TYPE_ROUTE
		) {
			items.push({
				to: "/admin/laboratoryUserRoutes?uri=generalConfig",
				title: "Rutas",
				desc: "Gestión de rutas asignadas a usuarios",
				icon: <MdOutlinePlace size={16} />,
			});
		}

		if (!userdata.isAgency || (userdata.isAgency && userdata.p_client)) {
			items.push({
				to: "/admin/users?uri=generalConfig",
				title: "Usuarios",
				desc: "Administración de usuarios",
				icon: <UserOutlined style={{ fontSize: 16 }} />,
				onClick: () => setAdminUsersType(CONSTANTS.USERS_MOBILE),
			});
		}

		if (!userdata.isAgency) {
			items.push({
				to: "/admin/items?uri=generalConfig",
				title: "Productos activos",
				desc: "Listado de productos activos del sistema",
				icon: <MdOutlineChecklist size={16} />,
			});
		}

		if (
			clientContract &&
			clientContract.activeExpoSection &&
			!userdata.isAgency
		) {
			items.push({
				to: "/admin/laboratoryEvents?uri=generalConfig",
				title: "Eventos",
				desc: "Configuración y administración de eventos",
				icon: <CalendarOutlined style={{ fontSize: 16 }} />,
			});
		}

		if (!userdata.isAgency) {
			items.push({
				to: "/admin/laboratoryAuditory?uri=generalConfig",
				title: "Auditoría pedidos",
				desc: "Consulta y descarga de auditoría de pedidos",
				icon: <BiImport size={16} />,
			});
		}

		if (!userdata.isAgency) {
			items.push({
				to: "/admin/laboratoryInitiatives?uri=generalConfig",
				title: "Iniciativas",
				desc: "Administración de iniciativas comerciales",
				icon: <CalendarOutlined style={{ fontSize: 16 }} />,
			});
		}

		if (!userdata.isAgency) {
			items.push({
				to: "/admin/laboratoryAlerts?uri=generalConfig",
				title: "Alertas",
				desc: "Gestión de alertas del negocio",
				icon: <AlertOutlined style={{ fontSize: 16 }} />,
			});
		}

		if (!userdata.isAgency) {
			items.push({
				to: "/admin/laboratoryConfigs?uri=generalConfig",
				title: "Configuraciones",
				desc: "Parámetros generales del laboratorio",
				icon: <SettingOutlined style={{ fontSize: 16 }} />,
			});
		}

		return items;
	}, [clientContract, userdata, setAdminUsersType]);

	const dynamicsItems = useMemo(() => {
		const items = [];

		if (clientContract && clientContract.activeMobileApp) {
			items.push({
				to: "/admin/laboratoryProductDiscounts?uri=generalConfig",
				title: "Dinámicas mobile",
				desc: "Reglas y descuentos para mobile",
				icon: <BiCoinStack size={16} />,
			});
		}

		if (
			clientContract &&
			clientContract.activeMobileApp &&
			clientContract.activeDiscountsForUsers
		) {
			items.push({
				to: "/admin/laboratoryUserDiscounts?uri=generalConfig",
				title: "Dinámicas vendedores mobile",
				desc: "Descuentos y reglas por vendedor mobile",
				icon: <TbDeviceMobile size={16} />,
			});
		}

		if (clientContract && clientContract.activeWebSeller) {
			items.push({
				to: "/admin/laboratoryWebSellerDiscounts?uri=generalConfig",
				title: "Dinámicas callcenter",
				desc: "Dinámicas comerciales para callcenter",
				icon: <FaHeadset size={16} />,
			});
		}

		return items;
	}, [clientContract]);

	const iaItems = useMemo(() => {
		const items = [];

		if (clientContract && clientContract.activeIASuggested) {
			items.push({
				to: `/admin/laboratorySuggestions?uri=generalConfig`,
				title: "Configuración de Sugeridos",
				desc: "Parámetros de configuracion para sugeridos",
				icon: <MdTune size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASuggested) {
			items.push({
				to: `/admin/suggestedProducts?uri=generalConfig`,
				title: "Listado de Sugeridos",
				desc: "Gestión y visualización de sugeridos",
				icon: <StockOutlined style={{ fontSize: 16 }} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: `/admin/laboratoryAgentPool/${clientId}?uri=generalConfig`,
				title: "Ruteo Agente",
				desc: "Configuración del ruteo del agente",
				icon: <MdTrackChanges size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: `/admin/laboratoryAgentConversations/${clientId}?uri=generalConfig`,
				title: "Conversaciones Agente",
				desc: "Historial de conversaciones del agente",
				icon: <MdOutlineMessage size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: `/admin/laboratoryAgentOrders/${clientId}?uri=generalConfig`,
				title: "Pedidos Agente",
				desc: "Pedidos gestionados por IA",
				icon: <BiBox size={16} />,
				badge: agentOrdersQty,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: `/admin/laboratoryAgentConfigs/${clientId}?uri=generalConfig`,
				title: "Configuración Agente",
				desc: "Parámetros de configuracion del agente",
				icon: <MdSettingsSuggest size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: `/admin/laboratoryMarketing/${clientId}?uri=generalConfig`,
				title: "Material de Marketing",
				desc: "Gestión de materiales para marketing",
				icon: <GiFiles size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: "/admin/laboratoryAgentTokens?uri=generalConfig",
				title: "Tokens",
				desc: "Visualizacion de Tokens usados",
				icon: <GiToken size={16} />,
			});
		}

		if (clientContract && clientContract.activeIASeller) {
			items.push({
				to: "/admin/laboratoryAgentProducts?uri=generalConfig",
				title: "Dinamicas Agente",
				desc: "Asignacion de productos y descuentos",
				icon: <GiPoolTriangle size={16} />,
			});
		}

		return items;
	}, [clientContract, agentOrdersQty]);

	const panel =
		activeSection === "dynamics"
			? {
					eyebrow: "Dinámicas",
					title: "Dinámicas / Ofertas",
					desc: "Sección para administrar las dinámicas de los productos",
					icon: <MdOutlineAppRegistration size={20} />,
					iconBg: COLORS.LightPrimary, //"#FAEEDA",
					iconColor: COLORS.Primary, //"#854F0B",
					items: dynamicsItems,
				}
			: activeSection === "ia"
				? {
						eyebrow: "IA",
						title: "Inteligencia Artificial",
						desc: "Sección para administrar configuraciones de aplicaciones IA",
						icon: <GiArtificialIntelligence size={20} />,
						iconBg: "#E1F5EE",
						iconColor: "#0F6E56",
						items: iaItems,
					}
				: {
						eyebrow: "Configuración General",
						title: "ERP",
						desc: "Administra tu aplicación y los datos de tu negocio",
						icon: <MdOutlineBusiness size={20} />,
						iconBg: "#E6F1FB",
						iconColor: "#185FA5",
						items: generalItems,
					};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
				<PrimaryButton
					onClick={() => navigate("/erp")}
					icon={<LoginOutlined />}
					style={{
						height: 30,
						border: `1px solid ${COLORS.MediumGrey}`,
						fontSize: 12,
					}}
				>
					Ir a sistema ERP
				</PrimaryButton>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						onClick={item.onClick}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<Badge
									count={item.badge}
									offset={[8, -4]}
									size="small"
									color="#E24B4A"
								>
									<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
										{item.icon}
									</CardIconWrap>
								</Badge>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
